"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterSizeGroupState = void 0;
var SfilterSizeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterSizeGroup");
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
var SfilterSizeOptionMode_init_1 = require("@/pages/common/states/sfilter/sections/size/SfilterSizeOptionMode.init");
exports.defaultSfilterSizeGroupState = {
    key: SfilterKey_1.SfilterKey.SIZE,
    name: 'Size',
    nameCustom: 'Custom',
    nameSizeRange: 'Size Range',
    nameGross: 'Gross',
    nameSaleable: 'Saleable',
    nameTo: 'to',
    nameUnlimited: 'Unlimited',
    opened: false,
    type: SfilterSizeGroup_1.SfilterSizeType.SALEABLE,
    optionMode: SfilterSizeOptionMode_init_1.defaultSfilterSizeOptionModeState,
};
